import { ThemeIcons } from "../types";

export const defaultIconAssignments: ThemeIcons = {
  loader: "senecaLoader"
};

export const goStudentLearning: ThemeIcons = {
  loader: "goStudentLoader"
};
